
import { useState, useEffect, useCallback } from 'react';
import { useBusinessOnboarding } from '@/hooks/useBusinessOnboarding';

export const usePackageSelection = () => {
  const { selectedPackage: contextPackage, handlePackageSelected } = useBusinessOnboarding();
  const [selectedPackage, setSelectedPackage] = useState<string | null>(null);
  const [initialPackage, setInitialPackage] = useState<string | null>(null);
  
  useEffect(() => {
    console.log('Package selection hook: ', { 
      contextPackage, 
      selectedPackage,
      initialPackage,
    });
  }, [contextPackage, selectedPackage, initialPackage]);
  
  useEffect(() => {
    if (contextPackage) {
      console.log('Setting initial selectedPackage from context:', contextPackage);
      setSelectedPackage(contextPackage);
      
      if (initialPackage === null) {
        setInitialPackage(contextPackage);
      }
    }
  }, [contextPackage, initialPackage]);
  
  // This function only updates the local state, not the context
  const handlePackageSelect = useCallback((packageId: string) => {
    console.log('Package selected locally:', packageId);
    setSelectedPackage(packageId);
  }, []);
  
  // This function updates the context and should only be called on "Continue"
  const updateContextPackage = useCallback((packageId: string) => {
    console.log('Updating context with package:', packageId);
    handlePackageSelected(packageId);
  }, [handlePackageSelected]);
  
  return {
    selectedPackage,
    initialPackage,
    handlePackageSelect,
    updateContextPackage
  };
};
